/** jQuery JavaScript for profit2ad functionality **/
(function (profit2ad, $) {

    profit2ad.subscriptionKey = null;
    profit2ad.locationAD = null;
    profit2ad.profitEnvironmentKey = null;
    profit2ad.exclusions = [];
    profit2ad.loaded = [];
    ;

    profit2ad.tableIndex = 0;

    profit2ad.types = [
        { index: 0, title: "Toegevoegd" },
        { index: 1, title: "Gewijzigd" },
        { index: 2, title: "Geblokkeerd" },
        { index: 3, title: "Fout" }
    ];

    profit2ad.boolTranslation = [
        { index: true, title: 'Ja' },
        { index: false, title: 'Nee' }
    ];

    /** Initializes the Javascript for Profit2AD */
    profit2ad.init = function (subscriptionKey, profitEnvironmentKey, locationAD) {
        profit2ad.subscriptionKey = subscriptionKey;
        profit2ad.profitEnvironmentKey = profitEnvironmentKey;
        profit2ad.locationAD = locationAD
        profit2ad.initFileUpload();
        profit2ad.bindDefinitionsEvent();
        profit2ad.bindDossierItemTypeEvent();
        profit2ad.bindGroupEvents();
        profit2ad.bindDefinitionEvents();
        profit2ad.bindTabs();

        document.querySelectorAll('a[data-bs-toggle="tab"]').forEach((el) => {
            el.addEventListener('hidden.bs.tab', (e) => {
                profit2ad.destroyTable(e.target.hash);
            });
        });

        document.querySelectorAll('a[data-bs-toggle="tab"]').forEach((el) => {
            el.addEventListener('shown.bs.tab', (e) => {
                profit2ad.exclusions = [];
                profit2ad.createTable(e.target.hash)
            });
        });
    }

    profit2ad.createTable = function (tabId) {

        // Create only once
        if (profit2ad.loaded[tabId] == true) {
            return;
        }

        switch (tabId) {
            case '#definitions':
                profit2ad.initEmployersTable('#upnformatemployerstable', '/Profit2AD/Home/SearchUpnFormatEmployers', 'CreateUpnFormatEmployer', 'DeleteUpnFormatEmployer');
                profit2ad.initEmployersTable('#emailformatemployerstable', '/Profit2AD/Home/SearchEmailFormatEmployers', 'CreateEmailFormatEmployer', 'DeleteEmailFormatEmployer');
                break;
            case '#fields':
                profit2ad.initFieldsTable();
                break;
            case '#groups':
                profit2ad.initGroupsTable('#groupstable', 'Profit gebruikers groep', '/Profit2AD/Home/SearchGroups', 'Groups', 'DetailsGroup', 'DetailsGroup', 'DeleteGroup');
                break;
            case '#organisationalunits':
                profit2ad.initGroupsTable('#organisationalunitstable', 'Profit organisatorische eenheden', '/Profit2AD/Home/SearchGroups', 'OrganisationalUnits', 'DetailsOrganisationalUnit', 'DetailsOrganisationalUnit', 'DeleteOrganisationalUnit');
                break;
            case '#functions':
                profit2ad.initGroupsTable('#functionstable', 'Profit functies', '/Profit2AD/Home/SearchGroups', 'Functions', 'DetailsFunction', 'DetailsFunction', 'DeleteFunction');
                break;
        }

        profit2ad.loaded[tabId] == true
    }

    profit2ad.destroyTable = function (tabId) {
        const tr = '<tr><td valign="top" colspan="4" class="dataTables_empty">Geen resultaten aanwezig in de tabel</td></tr>';
        switch (tabId) {
            case '#definitions':
                $('tbody', '#upnformatemployerstable').empty().append(tr);
                $('tbody', '#emailformatemployerstable').empty().append(tr);
                break;
            default:
                $('tbody', `${tabId}table`).empty().append(tr);
        }
    }

    profit2ad.initEmployersTable = function (tableId, searchUrl, createAction, deleteAction) {
        let table = $(tableId).DataTable(datatable.defaultDatatableOptions({
            ajax: {
                url: searchUrl,
                data: {
                    subscriptionKey: profit2ad.subscriptionKey,
                    profitEnvironmentKey: profit2ad.profitEnvironmentKey
                }
            },
            searchable: false,
            info: false,
            paging: true,
            orderFixed: {
                name: 'employerName',
                dir: 'asc'
            },
            columns: [
                { data: 'employerName', name: 'EmployerName', title: 'Werkgever', sortable: true, searchable: false },
                { data: 'organizationalUnit', name: 'OrganizationalUnit', title: 'Organisatorische eenheid', sortable: true, searchable: false },
                { data: 'domain', name: 'Domain', title: 'Domein', sortable: true, searchable: false },
                { responsivePriority: -1, defaultContent: '', orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 2],
                    width: '25%'
                },
                {
                    targets: [1],
                    width: '50%'
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/Profit2AD/Home/${deleteAction}?subscriptionKey=${profit2ad.subscriptionKey}&amp;profitEnvironmentKey=${profit2ad.profitEnvironmentKey}&amp;key=${full.key}"></a>`;
                    }
                }
            ]
        }));
        var columnHeader = table.column(-1).header();
        $(columnHeader).html(`<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-plus" title="Toevoegen" href="/Profit2AD/Home/${createAction}?subscriptionKey=${profit2ad.subscriptionKey}&amp;profitEnvironmentKey=${profit2ad.profitEnvironmentKey}"></a>`);
    }

    profit2ad.initFieldsTable = function () {
        let table = $('#fieldstable').DataTable(datatable.defaultDatatableOptions({
            disableautoreload: true,
            ajax: {
                url: '/Profit2AD/Home/SearchFields',
                data: {
                    subscriptionKey: profit2ad.subscriptionKey
                }
            },
            searchable: false,
            info: false,
            paging: true,
            orderFixed: {
                name: 'profitName',
                dir: 'asc'
            },
            columns: [
                { data: 'profitName', name: 'ProfitName', title: 'Profit veld', sortable: true, searchable: false },
                { data: 'adName', name: 'AdName', title: 'Entra ID / Active directory veld', sortable: true, searchable: false },
                { responsivePriority: -1, defaultContent: '', orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0],
                    width: '35%'
                },
                {
                    targets: [1],
                    width: '65%'
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/Profit2AD/Home/DeleteField?subscriptionKey=${profit2ad.subscriptionKey}&amp;key=${full.key}"></a>`;
                    }
                }
            ]
        }));
        var columnHeader = table.column(-1).header();
        $(columnHeader).html(`<a data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-plus" title="Toevoegen" href="/Profit2AD/Home/CreateField?subscriptionKey=${profit2ad.subscriptionKey}&amp;locationAD=${profit2ad.locationAD}"></a>`);
    }

    profit2ad.initGroupsTable = function (tableId, firstColumnTitle, searchUrl, source, createAction, detailsAction, deleteAction) {
        let table = $(tableId).DataTable(datatable.defaultDatatableOptions({
            ajax: {
                url: searchUrl,
                data: {
                    subscriptionKey: profit2ad.subscriptionKey,
                    source: source
                }
            },
            deferLoading: 0,
            searchable: false,
            info: false,
            paging: true,
            orderFixed: {
                name: 'profitName',
                dir: 'asc'
            },
            columns: [
                { data: 'profitName', name: 'ProfitName', title: firstColumnTitle, sortable: true, searchable: false },
                { data: 'adName', name: 'AdName', title: 'Entra ID / Active directory groep', sortable: true, searchable: false },
                { data: 'exclusions[]', name: 'Exclusions', title: 'Bevat uitsluiting', sortable: false, searchable: false },
                { data: 'exclusions[]', responsivePriority: -1, defaultContent: '', orderable: false, searchable: false } // Exclusions is used in the onclick of the edit-button to pass the data to the edit-window.
            ],
            columnDefs: [
                {
                    targets: [0, 1],
                    width: '33%'
                },
                {
                    targets: [2],
                    width: '13%',
                    render: function (data, type, full, meta) {
                        return data.length > 0 ? 'Ja' : 'Nee';
                    }
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        let aHrefs = [
                            `<a data-remove data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/Profit2AD/Home/${deleteAction}?subscriptionKey=${profit2ad.subscriptionKey}&amp;key=${full.key}"></a>`,
                            `<a data-details data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-edit" title="Bewerken" href="/Profit2AD/Home/${detailsAction}?subscriptionKey=${profit2ad.subscriptionKey}&amp;key=${full.key}"></a>`
                        ];
                        return aHrefs.join('\n');
                    }
                }
            ]
        }));
        var columnHeader = table.column(-1).header();
        $(columnHeader).html(`<a data-create data-bs-toggle="modal" data-bs-target="#modalcontainer" class="btn btn-datatable btn-outline-primary fas fa-plus" title="Toevoegen" href="/Profit2AD/Home/${createAction}?subscriptionKey=${profit2ad.subscriptionKey}&amp;source=Groups"></a>`);

        $(`${tableId} thead th [data-create]`).on('click', function (e) {
            profit2ad.exclusions = [];
        });

        table.on('draw', function (e, settings) {
            $(`${tableId} tbody td [data-details]`).on('click', function (e) {
                profit2ad.exclusions = table.cell(this.parentElement).data();
            });
        });
    }

    profit2ad.initLogTable = function () {
        $("#profit2adlogtable").DataTable(datatable.defaultDatatableOptions({
            ajax: {
                url: '/Profit2ADLog/Home/ADLogsGrid?searchFrom=' + $("#search").val() + '&searchTill=' + $("#searchend").val()
            },
            hideFooter: false,
            columns: [
                { data: "date", name: "Date", title: "Datum", orderable: true, searchable: false },
                { data: "state", name: "State", title: "Actie", orderable: true, searchable: true, enum: profit2ad.types },
                { data: "upn", name: "Upn", title: "Gebruiker", eorderable: true, searchable: true },
                { data: "employeeCode", name: "EmployeeCode", title: "Medewerkercode", orderable: true, searchable: true },
                { data: "success", name: "Success", title: "Succes", orderable: true, searchable: true, enum: profit2ad.boolTranslation },
                { responsivePriority: 2, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: 0,
                    width: '15%',
                    render: function (data, type, full, meta) {
                        return moment(data).format("DD-MM-YYYY HH:mm:ss");
                    }
                },
                {
                    targets: 1,
                    width: '10%',
                },
                {
                    targets: 2,
                    width: '25%',
                },
                {
                    targets: -1,
                    width: '100px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return '\
                            <a href="/Profit2ADLog/Home/Details?&key=' + full.key + '&searchFrom=' + $("#search").val() + '&searchTill=' + $("#searchend").val() + '" class="float-end btn btn-sm btn-outline-primary ms-2 px-3" title="Details"><i class="fas fa-magnifying-glass"> </i></a>';
                    }
                }
            ]
        }));

        $(document).on('keypress', "[date]", function (event) {
            if (event.which == 13) {
                event.preventDefault();
                // Simulate onchange event before retrieving the data as the date must be set in the url via this event.
                this.blur();
                datatable.dataTableSearch($('tr.filter'), $("#profit2adlogtable").DataTable());
            }
        });
    }

    profit2ad.initSearchDates = function () {
        $(document).on('change', "[date]", function () {
            $("#profit2adlogtable").DataTable().ajax.url('/Profit2ADLog/Home/ADLogsGrid?searchFrom=' + $("#search").val() + '&searchTill=' + $("#searchend").val());
        });
    }

    profit2ad.initDate = function () {
        $(document).on('change', "input[date]", function () {
            let value = $(this).val();
            if (value) {
                // First normalize the input string to support multiple input types
                let dateString = value.replace(/ /g, '-').replace(/[/]/g, '-');
                let dateArray = dateString.split('-');

                let date = new Date(dateArray[2] ?? 0, dateArray[1] - 1 ?? 0, dateArray[0] ?? 0);
                $(this).val([
                    date.getDate().toString().padStart(2, '0'),
                    (date.getMonth() + 1).toString().padStart(2, '0'),
                    date.getFullYear().toString().padStart(4, '0')].join('-'));
            } else {
                $(this).val(null);
            }
        });

        $(document).on('change', "input[datetime]", function () {
            let value = $(this).val();
            if (value) {
                // First normalize the input string to support multiple input types
                let dateString = value.replace(/ /g, '-').replace(/[/]/g, '-').replace(/:/g, '-');
                let dateArray = dateString.split('-');

                let date = new Date(dateArray[2] ?? 0, dateArray[1] - 1 ?? 0, dateArray[0] ?? 0, dateArray[3] ?? 0, dateArray[4] ?? 0);
                $(this).val([
                    date.getDate().toString().padStart(2, '0'),
                    (date.getMonth() + 1).toString().padStart(2, '0'),
                    date.getFullYear().toString().padStart(4, '0')].join('-')
                    + " " +
                    [date.getHours().toString().padStart(2, '0'),
                    date.getMinutes().toString().padStart(2, '0')].join(':'));
            }
            else {
                $(this).val(null);
            }
        })
    }

    /** Bind the tab events so the tab stays on the same tab **/
    profit2ad.bindTabs = function () {
        // Load the selected tab
        var hash = location.hash.replace(/^#x/, '');  // ^ means starting, meaning only match the first hash
        if (hash) {
            $('.nav-tabs a[href="#' + hash + '"]').tab('show');
            if (hash == "filters") {
                sourceFilters.reload();
            }
        }

        // Selected tab
        $('.nav-tabs a').on('shown.bs.tab', function (e) {
            var action = $("form").attr("action");
            var hash = e.target.hash.substring(1);

            var url = new URL(action, window.location.origin);
            url.hash = `x${hash}`;

            $("form").attr("action", url.toString());
        })

        $("form").data("url", $("form").attr("action"));
    }

    /** Bind the defintion change event */
    profit2ad.bindDefinitionsEvent = function () {
        $(document).on("change", "[data-employer-key]", function () {
            var $this = $(this).children("option:selected");
            $("[data-employer-name]", $(this).parent()).val($this.text());
        });
    }

    /** Bind the dossier item changed event */
    profit2ad.bindDossierItemTypeEvent = function () {
        $(document).on("change", "[data-alt-id='Profit2AdDossierItemTypeId']", function (evt) {
            $.ajax({
                url: "/Profit2AD/Home/DossierItemMarks",
                cache: false,
                data: {
                    clientKey: $("[data-clientkey]").val(),
                    profitEnvironmentKey: $("[data-profitenvironmentkey]").val(),
                    dossierItemTypeId: $(evt.target).val()
                },
                success: function (list) {
                    var selector = "[data-alt-id='" + $(evt.target).data('altId').replace('Type', 'Mark') + "'";
                    $(selector).empty().append($("<option />", { value: "", text: "Geen kenmerk" }));
                    if (list) {
                        $.each(list,
                            function () {
                                $(selector).append($("<option />", { value: this.id, text: this.description }));
                            });
                    }
                }
            });
        });
    }

    /** Bind the file upload */
    profit2ad.initFileUpload = function () {
        $(".custom-file-input").on("change", function () {
            var file = this.files[0];
            $(this).next(".custom-file-label").addClass("selected").html(file.name);
            $("input[type=hidden][data-filename]").val(file.name);
        });
    }

    /* Initialize search bar */
    profit2ad.initSearchBar = function () {
        $(document).on("click", "[data-category]", function () {
            var $this = $(this);
            var grid = $this.closest("grid");

            $("[data-category]", grid).each(function () {
                $(this).removeClass("active");
            });
            $this.addClass("active");
            $("[data-categoryfilter]", grid).val($this.data("category"));

            $("[data-currentpage]", grid).val(1);

            $("[data-activecategoryfilter]").html($(this).html());
            $("#searchform", grid).submit();
        });

        $(document).on("click", "[data-sort]", function () {
            var $this = $(this);
            var grid = $this.closest("grid");

            $("[data-sort]", grid).each(function () {
                $(this).removeClass("active");
            });
            $this.addClass("active");
            $("[data-sorting]", grid).val($this.data("sort"));
            $("[data-currentpage]", grid).val("1");
            $("#searchform", grid).submit();
        });

        $(document).on("click", "[data-display]", function () {
            var $this = $(this);
            var grid = $this.closest("grid");

            $("[data-display]", grid).each(function () {
                $(this).removeClass("active");
            });
            $this.addClass("active");
            $("[data-displaymode]", grid).val($this.data("display"));
            $("#searchform", grid).submit();
        });

        $(document).on("click", "[data-pager]", function () {
            var $this = $(this);
            var grid = $this.closest("grid");
            var currentPage = $("[data-currentpage]", grid);

            var page = parseInt(currentPage.val());
            if ($this.data("pager") === "next") {
                currentPage.val(page + 1);
            }
            if ($this.data("pager") === "prev") {
                currentPage.val(page - 1);
            }
            $("#searchform", grid).submit();
        });

        $("grid").each(function () {
            var grid = $(this);
            if ($("[data-initialload]", grid).val() === "True") {
                $("#searchform", grid).submit();
            }
        });
    }

    /** Bind group events */
    profit2ad.bindGroupEvents = function () {
        $(document).on("click", "[data-addgroup]", function () {
            profit2ad.addGroup();
        });

        $(document).on("click", "[data-addLine]", function () {
            profit2ad.addLine(this);
        });

        $(document).on("click", "[data-delete]", function () {
            var index = $(this).attr("data-delete");
            profit2ad.exclusions.splice(index, 1);
            profit2ad.redraw();
        });

        $(document).on("change", "[data-profitName]", function () {
            // Update field in the array
            var index = $(this).closest("[data-index]").attr("data-index");
            profit2ad.exclusions[index].profitName = $(this).val();
        })
        $(document).on("change", "[data-value]", function () {
            // Update value in the array
            var index = $(this).closest("[data-index]").attr("data-index");
            profit2ad.exclusions[index].value = $(this).val();
        });
    }

    /** Initialize the newly loaded group */
    profit2ad.initGroup = function () {
        profit2ad.maxGuidIndex = 0;
        profit2ad.redraw();
    }

    /** Redraw the set of exclusions */
    profit2ad.redraw = function () {
        $("[data-andgroup-placeholder]").html("");
        var groupKey = "";
        var currentGroup = "";
        var groupIndex = 0;
        var controlIndex = 0;

        $.each(profit2ad.exclusions, function (index, data) {
            if (groupKey != data.andGroup) {
                groupKey = data.andGroup;
                groupIndex++;

                var guidIndex = profit2ad.getGuidIndex(data.andGroup);
                if (guidIndex > profit2ad.maxGuidIndex)
                    profit2ad.maxGuidIndex = guidIndex;

                data.exclusionLabel = "Set " + groupIndex;
                currentGroup = profit2ad.createFromTemplate("[data-andgroup-template]", data, controlIndex)

                $("[data-andgroup-placeholder]").append(currentGroup);
            }

            data.exclusionLabel = "Set " + groupIndex;
            var exclusion = profit2ad.createFromTemplate("[data-exclusion-template]", data, controlIndex);
            exclusion.insertBefore($("[data-exclusion-placeholder]", currentGroup));

            controlIndex++;
        });

        global.rebindValidators();
    }

    /** Create a block of html from a template */
    profit2ad.createFromTemplate = function (templateSource, data, index) {
        var template = $(templateSource).html();
        template = template.replaceAll("INDEX", index);
        var newBlock = $(template);

        $.each(data, function (name, value) {
            var obj = $("[data-" + name + "]", newBlock)
            if (obj.length > 0) {
                if (obj.is("label"))
                    obj.text(value);
                else
                    obj.val(value);
            }
        });

        return newBlock;
    }

    /** Get the index from a guid, presuming this one is created with one */
    profit2ad.getGuidIndex = function (guid) {
        return parseInt(guid.substring(0, 8), 10) - 10000000;
    }

    /** Generate a guid, representing an index (for ordering) if presented with an index */
    profit2ad.generateGuid = function (index) {
        if (index) {
            index = index + 10000000
        } else {
            index = 'xxxxxxxx';
        }

        var guid = (index + '-xxxx-4xxx-yxxx-xxxxxxxxxxxx').replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });

        return guid;
    }

    /** Add an "and" group to the exclusions */
    profit2ad.addGroup = function () {
        // Add line as well.
        profit2ad.maxGuidIndex++;

        var newData = {
            key: profit2ad.generateGuid(),
            andGroup: profit2ad.generateGuid(profit2ad.maxGuidIndex),
            profitName: null,
            value: null,
        }

        profit2ad.exclusions.push(newData);

        profit2ad.redraw();
    }

    /** Add a line to an exclusion group */
    profit2ad.addLine = function (link) {
        // Find previous item in the array
        // First find it in thee current group, then in the previous group
        // Non exists = 0
        var parent = $(link).parent();
        var andGroup = $("[data-andGroup]", parent).first().val();
        var lastIndex = parseInt($("[data-index]", parent).last().attr("data-index"));

        var newData = {
            key: profit2ad.generateGuid(),
            andGroup: andGroup,
            profitName: null,
            value: null,
        }

        profit2ad.exclusions.splice(lastIndex + 1, 0, newData);

        profit2ad.redraw();
    }

    /** Bind events for the definitions tab **/
    profit2ad.bindDefinitionEvents = function () {
        $(document).on("click", "[data-add-format]", function () { profit2ad.addFormat($(this)); });
        $(document).on("click", "[data-remove-format]", function () { profit2ad.removeFormat($(this)); });

        profit2ad.updateAllIdGroupIds();
    }

    /** Add a format to the list **/
    profit2ad.addFormat = function ($this) {
        var itemToClone = $this.closest("[data-index]")
        $("[data-add-format]", itemToClone).toggle(false);

        var root = $this.closest("[data-count]");
        var count = root.attr("data-count")
        root.attr("data-count", parseInt(count) + 1);

        var newItem = itemToClone.clone(true);

        profit2ad.updateIds(newItem, count, count, true);
        root.append(newItem);
    }

    /** Remove a format to the list **/
    profit2ad.removeFormat = function ($this) {

        var root = $this.closest("[data-count]");
        var count = root.attr("data-count")
        root.attr("data-count", parseInt(count) - 1);

        var itemToRemove = $this.closest("[data-index]")

        itemToRemove.remove();
        profit2ad.updateIdGroupIds(root);
    }

    /** Update all group id's for all groups **/
    profit2ad.updateAllIdGroupIds = function () {
        $("[data-count]").each(function (index) {
            profit2ad.updateIdGroupIds($(this));
        });
    }

    /** Update all group id's for 1 group **/
    profit2ad.updateIdGroupIds = function (root) {
        var count = root.attr("data-count")
        $("[data-index]", root).each(function (index) {
            profit2ad.updateIds($(this), index, (parseInt(count) - 1), false);
        });
    }

    /** Update id's within a format definition block **/
    profit2ad.updateIds = function (parent, index, maxIndex, clearInput) {
        parent.attr("data-index", index);
        var inputs = $("input", parent);
        inputs.attr("id", inputs.attr("id").replace(/_\d+_/, "_" + index + "_"));
        inputs.attr("name", inputs.attr("name").replace(/\[\d+\]/, "[" + index + "]"));
        if (clearInput) {
            inputs.val("");
            inputs.attr("value", "");
        }
        var inputs = $("[data-valmsg-for]", parent);
        inputs.attr("data-valmsg-for", inputs.attr("data-valmsg-for").replace(/\[\d+\]/, "[" + index + "]"));

        $("[data-add-format]", parent).toggle(parseInt(index) == parseInt(maxIndex));

        if (index > 0)
            parent.find("[data-remove-format]").show();

    }

}(window.profit2ad = window.profit2ad || {}, jQuery));
